package devxertech.com.pages.services.webServices.serviceKeyFactor

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.commons.TeamService
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px


@Composable
fun ServiceKeySection() {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = if (breakpoint > Breakpoint.MD) 40.px else 40.px,
                bottom = if (breakpoint < Breakpoint.MD) 20.px else 30.px),
        contentAlignment = Alignment.Center
    ) {
        val spanTextModifier = Modifier
            .fontFamily(Constants.ROBOTO_FONT)
            .fontSize(if (breakpoint > Breakpoint.MD) 35.px else 20.px)
            .lineHeight(if (breakpoint > Breakpoint.MD) 37.4.px else 36.px)
            .letterSpacing(0.5.px)
            .textTransform(TextTransform.Uppercase)

        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                text = "Our Key Factors", modifier = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(18.px)
                    .color(sitePalette.commonSecondaryButtonColor.rgb)
                    .fontWeight(FontWeight.Medium)
                    .lineHeight(15.4.px)
                    .textTransform(TextTransform.Uppercase)
                    .padding(bottom = 10.px)
            )
            Row(
                modifier = Modifier.flexWrap(FlexWrap.Wrap),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                SpanText(
                    text = "Our ", modifier = spanTextModifier
                        .color(sitePalette.commonSecondaryButtonColor.rgb)
                        .fontWeight(FontWeight.ExtraBold)
                )
                SpanText(
                    text = "Six Key Factors ", modifier = spanTextModifier
                        .color(sitePalette.primary.rgb)
                        .fontWeight(FontWeight.ExtraBold)
                )
                SpanText(
                    text = "for ", modifier = spanTextModifier
                        .color(sitePalette.commonSecondaryButtonColor.rgb)
                        .fontWeight(FontWeight.ExtraBold)
                )
                SpanText(
                    text = "Web Design & Development", modifier = spanTextModifier
                        .color(sitePalette.commonSecondaryButtonColor.rgb)
                        .fontWeight(FontWeight.ExtraBold)
                )
            }
        }
    }
    Row(
        modifier = Modifier.fillMaxWidth()
            .padding(bottom = if (breakpoint < Breakpoint.MD) 20.px else if (window.screen.width > 1600) 10.px else 80.px)
            .flexWrap(FlexWrap.Wrap),
        horizontalArrangement = Arrangement.Center
    ) {
        TeamService(
            bullet = true,
            image = Res.Image.key_factor,
            title = "User Experience",
            description = "Prioritize clear navigation, readable fonts, and responsive layouts that work well across all devices.\n" +
                    "We considers ease of use, loading speed, and logical layout to keep users engaged.",

            )
        TeamService(
            bullet = true,
            image = Res.Image.key_factor_2,
            title = "Mobile Optimization",
            description = "We adopt a mobile-first approach, optimizing layouts and loading times to deliver a seamless experience." +
                    "\n" +
                    "We ensure that our designs adjust smoothly across a wide range of devices and screen sizes.",

            )
        TeamService(
            bullet = true,
            image = Res.Image.key_factor_3,
            title = "SEO Optimization",
            description = "Our SEO specialists implement best practices, from meta tags to keyword integration." +
                    "\n" +
                    "We also prioritize clean coding structures and fast load times, which search engines with higher rankings. ",

            )
        if (window.screen.width < 1600) {
            TeamService(
                bullet = true,
                image = Res.Image.key_factor_4,
                title = "Loading Speed",
                description = "We enhance performance by optimizing,leveraging caching, and minifying code," +
                        "resulting in faster load times.\n" +
                        "Through performance testing, we eliminate any bottlenecks to maintain a high-speed experience for all users.",
                modifier = Modifier.padding(top = 0.px)
            )


            TeamService(
                bullet = true,
                image = Res.Image.key_factor_5,
                title = "Branding",
                description = "We craft professional,refined designs that capture and communicate the brand's distinctive voice.\n" +
                        "We ensure every detail contributes to a memorable identity By tailoring each visual element. ",

                )
            TeamService(
                bullet = true,
                image = Res.Image.key_factor_6,
                title = "Security",
                description = "We implement robust security protocols, including HTTPS, SSL certifications to protect sensitive data. " +
                        "\n" +
                        "We align with industry standards to ensure users and clients feel confident using our websites."

            )
        }
    }
    if (window.screen.width > 1600) {
        Row(
            modifier = Modifier.fillMaxWidth()
                .padding(top = 0.px, bottom = if (window.screen.width > 1600) 40.px else 70.px).display(DisplayStyle.Flex)
                .flexWrap(FlexWrap.Wrap),
            horizontalArrangement = Arrangement.Center
        ) {
            TeamService(
                bullet = true,
                image = Res.Image.key_factor_4,
                title = "Loading Speed",
                description = "We enhance performance by optimizing  leveraging caching, and minifying code, resulting in faster load times." +
                        "\n" +
                        "Through performance testing, we eliminate any bottlenecks to maintain a high-speed experience for all users.",

                )
            TeamService(
                bullet = true,
                image = Res.Image.key_factor_5,
                title = "Branding",
                description = "We craft professional, refined designs that capture and communicate the brand's distinctive voice.\n" +
                        "We ensure every detail contributes to a memorable identity By tailoring each visual element. ",

                )
            TeamService(
                bullet = true,
                image = Res.Image.key_factor_6,
                title = "Security",
                description = "We implement robust security protocols, including HTTPS, SSL certifications to protect sensitive data. " +
                        "\n" +
                        "We align with industry standards to ensure users and clients feel confident using our websites."

            )
        }
    }
}



